import { render, staticRenderFns } from "./VerificationDisplay.vue?vue&type=template&id=65f5c77c&scoped=true&"
import script from "./VerificationDisplay.vue?vue&type=script&lang=js&"
export * from "./VerificationDisplay.vue?vue&type=script&lang=js&"
import style0 from "./VerificationDisplay.vue?vue&type=style&index=0&id=65f5c77c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f5c77c",
  null
  
)

export default component.exports